<template>
        <div class="map-mobile-location-info" v-if="mapItem">
            <div class="info-row">
                <div class="info">
                    <div class="info-label">{{ $t('map.cmsItem.floor') }}</div>
                    <div class="info-value muted">{{ level || '-' }}</div>
                </div>
                <div class="info">
                    <div class="info-label">{{ $t('map.cmsItem.address') }}</div>
                    <div class="info-value muted">{{ address || '-' }}</div>
                </div>
            </div>

            <div v-if="tr(cmsItem?.description)" class="description">
                <div class="description-value" v-html="tr(cmsItem?.description)"></div>
            </div>

            <!-- Proof of concept -->
            <!--        <div class="text-left">-->
            <!--            <p class="h5 mt-3">To avoid delays, please arrive 30min before your appointment.</p>-->
            <!--            <h6 class="my-3">Bring the following document:</h6>-->
            <!--            <b-form-group>-->
            <!--                <b-checkbox size="lg"><span class="f-12">Admission Card</span></b-checkbox>-->
            <!--            </b-form-group>-->
            <!--            <b-form-group>-->
            <!--                <b-checkbox size="lg"><span class="f-12">Specialist's Prescription</span></b-checkbox>-->
            <!--            </b-form-group>-->
            <!--            <hr>-->
            <!--            <b-form-group label="Contact us">-->
            <!--                <b-btn variant="light" class="text-left py-2" href="#" block>-->
            <!--                    <i class="fas fa-phone mr-1"/>-->
            <!--                    (526) 648-9321-->
            <!--                </b-btn>-->
            <!--            </b-form-group>-->
            <!--            <b-form-group label="More information">-->
            <!--                <b-btn variant="light" class="text-left py-2" href="#" block>-->
            <!--                    <i class="fas fa-globe mr-1"/>-->
            <!--                    Visit our Website-->
            <!--                </b-btn>-->
            <!--            </b-form-group>-->
            <!--            <b-form-group label="Your opinion matter">-->
            <!--                <b-btn variant="light" class="text-left py-2" href="#" block>-->
            <!--                    <i class="fas fa-thumbs-up mr-1"/>-->
            <!--                    Feedback and evaluation-->
            <!--                </b-btn>-->
            <!--            </b-form-group>-->

            <!--            <iframe width="350" height="200" src="https://www.youtube.com/embed/XPpjoRauT4c?si=aNMoRRnLqdOBrZjI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>-->
            <!--        </div>-->
        </div>
</template>

<script>
export default {
    name: `map-mobile-location-info`,
    props: {
        mapItem: { type: Object, default: null }
    },
    computed: {
        cmsItem() {
            return this.mapItem.cmsItem;
        },
        level() {
            const floorItem = this.mapItem.map.getFloorById(this.mapItem.floorId);
            return this.tr(floorItem?.name);
        },
        address() {
            const address = this.tr(this.cmsItem?.address) || this.tr(this.mapItem?.address);
            const office = this.tr(this.cmsItem?.office) || this.tr(this.mapItem?.office);
            const room = this.tr(this.cmsItem?.room) || this.tr(this.mapItem?.room);
            return address || office || room || null;
        }
    },
};
</script>

<style lang="scss" scoped>
    .info-row {
        display: flex;
        border-top: 1px solid var(--border-color);
        border-bottom: 1px solid var(--border-color);
        padding-block: 10px;
        margin-block: 20px 10px;

        .info {
            flex: 1 1 auto;
            padding: 0 15px;
            text-align: start;

            .info-label {
                font-weight: 500;
                font-size: 10pt;
                color: var(--color-muted);
                white-space: nowrap;
            }

            .info-value {
                font-weight: 600;
                font-size: 11pt;
            }
        }

        .info + .info {
            border-left: 1px solid var(--border-color);
        }
    }

    .description {
        margin-block: 1.25rem;
        text-align: left;
        font-size: 11pt;
        line-height: 1.4;
        color: var(--color-dark);
        display: flex;
        flex-direction: column;
        padding-inline: 8px;

        .description-label {
            font-weight: 600;
            font-size: 13pt;
            margin-bottom: 0.5rem;
        }

        :deep(.description-value) {
            font-weight: 400;
            font-size: 11pt;
            line-height: 1.4;
            color: var(--color-dark);

            h2, h3, h4 {
                font-size: 13pt;
                font-weight: 600;
                margin-bottom: 1rem;
                font-family: inherit;
                text-wrap: balance;
            }

            ul {
                padding: 0;
                padding-left: 1rem;
                margin: 0;
                list-style: none;

                display: flex;
                flex-direction: column;

                li {
                    padding: 0.75rem;
                    text-wrap: pretty;

                    &::before {
                        content: "";
                        float: left;
                        margin-top: 0.5rem;
                        margin-left: -1rem;
                        display: block;
                        height: 6px;
                        width: 6px;
                        border-radius: 2px;
                        background-color: var(--border-color);
                    }
                }

                :nth-child(n) {
                    border-bottom: 1px solid #f0f0f0;
                }

                :nth-last-child(1) {
                    border-bottom: none;
                }
            }
        }

    }
</style>
